import React, { useContext, useEffect, useRef, useState } from 'react';
import debounce from 'debounce';

import Grid from '@material-ui/core/Grid';
import { InputAdornment } from '@material-ui/core';
import PhoneIcon from '@material-ui/icons/Phone';
import LinearProgress from '@material-ui/core/LinearProgress';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'

import FireDataContext from '../../services/firebase/FireDataContext';
import OrganizationMembers from './members/OrganizationMembers';
import Spacer from '../../app/common/ui/Spacer';
import MemberMiniMenu from '../members/menus/MemberMiniMenu';
import TariffInput from '../tariffs/TariffInput';
import OrganizationAddressInput from '../members/timesheets/OrganizationAddressInput';
import AuthContext from '../../services/firebase/AuthContext';
import { timestamp } from '../../app/data/validate';
import { keyGen } from '../../services/keygen';

const ClientOrganizationContent = ({ value, onChange }) => {
    const [organization, setOrganization] = useState(value ? { ...value } : undefined);
    const nameRef = useRef();
    const phoneRef = useRef();

    // console.log('ClientOrganizationContent', value, organization)
    const handleChange = debounce(fragment => {
        const state = { ...organization, ...fragment };
        onChange(state);
        setOrganization(state);
    }, 500);

    return (
        <Paper style={{ padding: '1rem' }}>
            <Grid container spacing={2}>
                <Grid item xs={12} lg={4}>
                    <Typography variant="h5" color="textSecondary">{organization?.name || 'New Organization'}</Typography>
                </Grid>
            </Grid>
            <Spacer />
            <Grid container spacing={2}>
                <Grid item xs={12} lg={4}>
                    <TextField
                        label="Organization Name"
                        defaultValue={organization?.name}
                        inputRef={nameRef}
                        onChange={() => handleChange({ name: nameRef.current.value })}
                        variant="outlined"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} lg={2}>
                    <TextField
                        label="Phone Number"
                        defaultValue={organization?.phoneNumber}
                        inputRef={phoneRef}
                        onChange={() => handleChange({ phoneNumber: phoneRef.current.value })}
                        variant="outlined"
                        fullWidth
                        InputProps={{
                            startAdornment: <InputAdornment position="start"><PhoneIcon /></InputAdornment>,
                        }}
                    />
                </Grid>
                <Grid item xs={12} lg={4}>
                    <OrganizationAddressInput organization={organization} title="Invoice Address" onChange={handleChange} />
                </Grid>
                <Grid item xs={12}>
                    <TariffInput
                        tariff={organization?.defaultTariff || 'tier1'}
                        onChange={code => handleChange({ defaultTariff: code })}
                        title='Please select a default jurisdiction for referrals'
                    />
                </Grid>
            </Grid>
        </Paper>
    );
}

const ClientOrganizationPage = ({ id }) => {
    const db = useContext(FireDataContext);
    const [organization, setOrganization] = useState(undefined);
    const { currentUser: { uid } } = useContext(AuthContext);

    useEffect(() => {
        if (id) {
            const fetch = async () => {
                const data = await db.get({ path: `organizations/${id}` });
                setOrganization({ ...data });
            }

            fetch();
        }
        else {
            const newId = `00000${keyGen(15)}`;
            const payload = {
                name: 'New Referrer',
                uid,
                ts: timestamp()
            };

            db.update({
                path: `organizations/${newId}`,
                payload
            })
                .then(() => setOrganization({ ...payload, id: newId }))
                .catch(error => console.log(error));
        }
    }, [id, db, uid]);

    const handleChange = state => {
        const payload = { ...organization, ...state, type: 'cais-client', adminOrganization: 'WHuoyDs7zcB8wUU7euiC', uid, ts: timestamp() };

        db.update({
            path: `organizations/${organization.id}`,
            payload
        })
            .then(result => console.log('update result', result));
    }

    return (
        <MemberMiniMenu>
            {
                (id && !organization) ? <LinearProgress /> :
                    <React.Fragment>
                        <ClientOrganizationContent value={organization} onChange={handleChange} />
                        {organization?.id && <OrganizationMembers id={organization.id} />}
                    </React.Fragment>
            }
        </MemberMiniMenu>
    );
};

export default ClientOrganizationPage;